import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as CloseIcon } from '../../../public/assets/css/ontario-design-system/icons/ontario-icon-close.svg';

interface CustomPopupProps {
  onClickOutside?: (closable?: boolean) => void;
  handleCustomEvent?: (event: any) => void;
  children: React.ReactNode;
  isVisible: boolean;
  id?: string;
  title?: string;
  closable?: boolean;
  handleModalClose?: () => void;
  customClass?: string;
  customContentClass?: string;
}

const CustomPopup = ({
  onClickOutside,
  handleCustomEvent,
  children,
  isVisible,
  id,
  title,
  closable,
  handleModalClose,
  customClass,
  customContentClass,
}: CustomPopupProps) => {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      console.log('handleClickOutside');
      if (ref.current) {
        if (closable && handleModalClose) {
          const close = ref.current?.querySelector('.modal-close-button');
          if (close && close.contains(event.target)) {
            event.stopPropagation();
            handleModalClose();
          } else if (event.target.nodeName === 'BUTTON' && !ref.current.contains(event.target)) {
            handleModalClose();
          }
        } else if (!ref.current?.contains(event.target) && handleCustomEvent) {
          event.stopPropagation();
          handleCustomEvent(event);
        } else if (!ref.current?.contains(event.target) && onClickOutside) {
          event.stopPropagation();
          onClickOutside(closable);
        }

        if (handleCustomEvent)
          handleCustomEvent(event);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setShow(isVisible);
  }, [isVisible]);

  return (
        <div className={`${customClass ?? ''} submenu-content`}
          style={{
              visibility: show ? 'visible' : 'hidden',
          }}
          ref={ref}
          role="dialog"
          id={id}
        >
          <div className={`${customContentClass} modal-content`}>
            {(title || closable) && (
                <div className='modal-header'>
                  <span style={{padding: '0.75rem 0.5rem'}}><strong>{title ?? ''}</strong></span>
                  <button className='message_button modal-close-button'>
                    <CloseIcon />
                  </button>
                </div>
            )}
            {children}
          </div>
        </div>
  );
};

export default CustomPopup;
